import { useMutation } from "react-query";
import useApi from "utils/api/useApi";
import { useSnackbar } from "notistack";

export const useDeleteProductTypeInfo = () => {
  const api = useApi();
  const { enqueueSnackbar } = useSnackbar();
  const deleteProductTypeInfo = async (product_info_id: number) => {
    const res = await api
      .path("item_class/product_info/delete", {product_info_id: product_info_id})
      .del();
    if (res?.data?.status === 0) {
      enqueueSnackbar("Delete item successfully!", {
        variant: "success",
      });
    } else {
      enqueueSnackbar(`Delete item faiiled! ${res?.data?.message}`, {
        variant: "error",
      });
    }
    return res?.data
  };

  const { data, isLoading, error, mutate } = useMutation((product_info_id: number) => deleteProductTypeInfo(product_info_id));

  return {
    deleteProductTypeInfoData: data,
    deleteProductTypeInfoError: error,
    deleteProductTypeInfoLoading: isLoading,
    deleteProductTypeInfoMutate: mutate,
  };
};
